import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { useDispatch } from "react-redux";
import { setAccount, setToken } from "../../reducer/userReducer";
import CachedItem, { CacheItem } from "../../config/cache";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Function to handle the callback and retrieve the access token

    const handleAuthCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get("code");
      console.log("code", code);
      console.log(window.location.href); // should show full URL
      console.log(location.search); // should be "?code=test123"

      if (code) {
        try {
          const response = await fetch(
            `https://nobi-staging.onrender.com/api/v1/auth/callback?code=${code}`,
            {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            }
          );

          const data = await response.json();
          console.log("API response:", data);

          if (data.success && data.accessToken) {
            CacheItem(CachedItem.token, data?.accessToken, true);
            localStorage.setItem("accessToken", data.accessToken);

            dispatch(setToken(data.accessToken));

            if (data?.account) {
              dispatch(setAccount(data?.account));
              localStorage.setItem("account", JSON.stringify(data?.account));
            }

            // Redirect to the welcome page
            navigate(Paths.welcome);
          } else {
            console.error("Login failed: Unable to retrieve access token.");
            navigate("/login");
          }
        } catch (error) {
          console.error("Failed to handle Auth0 callback:", error);
          navigate("/login");
        }
      } else {
        console.error("Login failed: Authorization code not found.");
        navigate("/login");
      }
    };

    // Run the handleAuthCallback function
    handleAuthCallback();
  }, []);

  return <p>Logging in...</p>;
};

export default AuthCallback;
